import { Component, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// TODO: need to rework [ future release ]
import { SideBarItem } from './sidebar-nav.model';
import { LocalStorageUtilityService } from '@shared/services/local-storage-utility.service';

const SIDEBAR_COLLAPSED_STORAGE_KEY = 'sidebar-collapsed';

@Component({
  selector: 'spark-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.scss']
})
export class SidebarNavComponent implements OnInit, OnDestroy {
  @Input()
  items: Array<Array<SideBarItem>> = [];

  private _isCollapsed: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private localStorageUtility: LocalStorageUtilityService
  ) {}

  ngOnInit(): void {
    // Load collapsed state from localStorage, default to false (expanded) if not found
    this._isCollapsed = this.localStorageUtility.get(SIDEBAR_COLLAPSED_STORAGE_KEY, false);
    // Set initial body class based on current state
    this.updateBodyClass();
  }

  ngOnDestroy(): void {
    // Clean up body classes when component is destroyed
    this.document.body.classList.remove('sidebar-collapsed', 'sidebar-expanded');
  }

  public get isCollapsed(): boolean {
    return this._isCollapsed;
  }

  public get logoUrl(): string {
    return this.isCollapsed
      ? '/assets/theme/logo-brandmark-reverse.png'
      : '/assets/theme/logo-brand-reverse.png';
  }

  public onToggleCollapse(): void {
    this._isCollapsed = !this._isCollapsed;
    this.localStorageUtility.set(SIDEBAR_COLLAPSED_STORAGE_KEY, this._isCollapsed);
    this.updateBodyClass();
  }

  private updateBodyClass(): void {
    // Remove existing classes
    this.document.body.classList.remove('sidebar-collapsed', 'sidebar-expanded');
    
    // Add appropriate class based on current state
    if (this._isCollapsed) {
      this.document.body.classList.add('sidebar-collapsed');
    } else {
      this.document.body.classList.add('sidebar-expanded');
    }
  }
}
